import React from "react";
import ReactApexChart from "react-apexcharts";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchDoctorDashboardData } from "../../../../redux/reducers/doctorDashboardSlice";
const VetSpecializationPieChart = () => {
  const dispatch = useDispatch();
  const { vetSpecial, loading } = useSelector((state) => state.doctorDashboard);

  useEffect(() => {
    dispatch(fetchDoctorDashboardData());
  }, [dispatch]);

  const labels = vetSpecial.map(item => item.speciality);
  const series = vetSpecial.map(item => item.count);

  const options = {
    chart: { 
      type: "pie",
      background: 'transparent',
    },
    labels,
    colors: [
      '#6366F1', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981',
      '#3B82F6', '#EC4899', '#84CC16', '#F97316', '#06B6D4'
    ],
 legend: {
  position: "right",
  offsetY: 0,
  height: 280,
  markers: { width: 12, height: 12, strokeWidth: 0, radius: 6 },
  labels: {
    colors: "#374151",
    useSeriesColors: false,
    fontSize: '14px',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500
  },
  itemMargin: { horizontal: 45, vertical: 5 },
  formatter: function (seriesName, opts) {
    const count = opts.w.config.series[opts.seriesIndex];
    return `<span style="margin-left:3px;"> ${seriesName} - ${count}`;
  }
},

    dataLabels: { 
      enabled: true,
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex]
      },
      style: {
        fontSize: '12px',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 'bold',
        colors: ['#fff']
      },
      dropShadow: {
        enabled: true,
        top: 1,
        left: 1,
        blur: 1,
        color: '#000',
        opacity: 0.45
      }
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['#fff']
    },
    tooltip: {
      enabled: true,
      theme: 'light',
      style: {
        fontSize: '12px',
        fontFamily: 'Inter, sans-serif'
      },
      y: {
        formatter: function(val) {
          return val + " specialists"
        }
      }
    },
    responsive: [{
      breakpoint: 768,
      options: {
        legend: {
          position: 'bottom',
          offsetY: 0,
          height: 'auto'
        }
      }
    }]
  };

  if (loading && !vetSpecial.length) {
    return (
      <div className="rounded-lg shadow border border-gray-200 bg-white p-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">Vet Specialization</h3>
        <div className="flex items-center justify-center h-80">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
          <p className="ml-4 text-gray-600">Loading chart...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg shadow border border-gray-200 bg-white p-6">
      <h3 className="text-lg font-semibold mb-4 text-gray-800">Vet Specialization</h3>
      <ReactApexChart options={options} series={series} type="pie" height={320} />
    </div>
  );
};

export default VetSpecializationPieChart;